import Vue from 'vue';
import VueEnums from 'vue-enums';

Vue.use(VueEnums);
